/** 当前登录用户头像字：展示名的第一个字符，没有名字时用 W。 */
export function userInitial(name?: string | null) {
  const text = name?.trim() || '';
  return text ? text.charAt(0).toUpperCase() : 'W';
}
